"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.webSearch.name': 'Wyszukiwanie w Internecie',
    'tools.webSearch.description': 'Wyszukaj aktualne informacje w internecie',
};
